// extracted by mini-css-extract-plugin
export var cardLayout = "_54-1";
export var paginationContainer = "_54-0";